import React, { useMemo, useEffect } from 'react';
import { orderBy, uniqBy } from 'lodash';

import Subject from 'containers/Student/Marks/Certificate/Subject';

import { useStudentMarkStore } from 'store/student/useStudentMarkStore';

const Summary = () => {
	// Use student's mark store
	const [grades, grade, courses, marks, active, onInit, onReset] = useStudentMarkStore(state => [
		state.grades,
		state.grades.find(g => g.id === state.active),
		state.courses,
		state.marks,
		state.active,
		state.onInit,
		state.onReset
	]);

	// Filter out subjects that are in current grades
	const subjects = useMemo(() => {
		// Filter subject's from marks
		const fromMarks = marks?.reduce((result, mark) => {
			return result.some(subject => subject.id === mark.subject.id) || grade.id !== mark.gradeId
				? result
				: [...result, mark.subject];
		}, []);

		// Remove duplicates and sort results by subject's title
		return orderBy(uniqBy([...fromMarks], 'id'), 'order');
	}, [grades, marks, active]);

	return (
		<div className="max-w-full overflow-x-auto">
			<table className="w-full border-separate border-spacing-0">
				<thead>
					<tr>
						<th className="p-2 pl-3 first:border-l first:rounded-tl-lg last:rounded-tr-lg border-r border-b border-t border-neutral-100 dark:border-neutral-700 text-neutral-700 dark:text-neutral-200 whitespace-nowrap">Mācību kurss</th>
						<th className="p-2 first:border-l first:rounded-tl-lg last:rounded-tr-lg border-r border-b border-t border-neutral-100 dark:border-neutral-700 text-neutral-700 dark:text-neutral-200 whitespace-nowrap">Kursa vērtējums</th>
					</tr>
				</thead>
				<tbody>
					{subjects?.map(subject =>
						<Subject key={subject.id} subject={subject} />
					)}
				</tbody>
			</table>
		</div>
	);
};

export default Summary;